import EntityTypeEnum from 'common/enums/entityTypeEnum'
import {
  TwoStepPaymentFormInterface,
  TwoStepPaymentFormStepInterface,
  TwoStepPaymentFormUiPropsInterface,
} from 'common/types/entities/two-step-payment-form-interface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'

export interface TwoStepPaymentFormStepCreatorProps
  extends Partial<TwoStepPaymentFormUiPropsInterface> {
  parentId: string
}

export const createTwoStepPaymentFormStepOptIn = ({
  parentId,
  headline = '',
  subHeadline = '',
  buttonText = '',
  buttonSubText = '',
  footerText = '',
}: TwoStepPaymentFormStepCreatorProps) => {
  const twoStepPaymentFormStepOptIn: TwoStepPaymentFormStepInterface = {
    ...generateBaseEntity(EntityTypeEnum.TwoStepPaymentFormStepOptIn, parentId),
    headline,
    subHeadline,
    buttonText,
    buttonSubText,
    footerText,
    childIds: [],
  }

  return twoStepPaymentFormStepOptIn
}

export const createTwoStepPaymentFormStepPayment = ({
  parentId,
  headline = '',
  subHeadline = '',
  buttonText = '',
  buttonSubText = '',
  footerText = '',
}: TwoStepPaymentFormStepCreatorProps) => {
  const twoStepPaymentFormStepPayment: TwoStepPaymentFormStepInterface = {
    ...generateBaseEntity(
      EntityTypeEnum.TwoStepPaymentFormStepPayment,
      parentId,
    ),
    headline,
    subHeadline,
    buttonText,
    buttonSubText,
    footerText,
    childIds: [],
  }

  return twoStepPaymentFormStepPayment
}

export const createTwoStepPaymentForm = (
  parentId: string,
  masterBlockId?: MasterBlockIdType,
) => {
  const twoStepPaymentForm: TwoStepPaymentFormInterface = {
    ...generateBaseEntity(
      EntityTypeEnum.TwoStepPaymentForm,
      parentId,
      masterBlockId,
    ),
    headerUnderlineColor: 'rgba(0, 116, 199, 1)',
    buttonBackgroundColor: 'rgba(0, 116, 199, 1)',
    buttonTextColor: 'rgba(255, 255, 255, 1)',
    headerBackgroundColor: 'rgba(0, 0, 0, 0.8)',
    headerTextColor: 'rgba(255,255,255, 1)',
    backgroundColor: 'rgba(255, 255, 255, 0)',
    border: {
      radius: {
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
      },
      width: 2,
      color: 'rgba(0, 0, 0, 0.8)',
      style: BorderStyleEnum.none,
    },
    padding: {
      paddingTop: 5,
      paddingRight: 5,
      paddingBottom: 5,
      paddingLeft: 5,
    },
    childIds: [],
  }

  if (masterBlockId) {
    twoStepPaymentForm.masterBlockId = masterBlockId
  }

  return twoStepPaymentForm
}
